import {QueryClient} from '@tanstack/react-query';

const ONE_DAY_MS = 1000 * 60 * 60 * 24;
const gatewayUserScopedMetaKey = 'gatewayUserScoped';

export const gatewayUserScopedQueryOptions = {
    gcTime: ONE_DAY_MS,
    networkMode: 'always' as const,
    retry: false,
    meta: {
        [gatewayUserScopedMetaKey]: true
    }
};

export const gatewayRealtimeQueryOptions = {
    ...gatewayUserScopedQueryOptions,
    staleTime: Infinity
};

export function invalidateGatewayUserScopedQueries(queryClient: QueryClient) {
    console.info('(gatewayQueryUtils) Invalidating user-scoped gateway queries...');
    queryClient.invalidateQueries({
        predicate: query => query.meta?.[gatewayUserScopedMetaKey] === true
    });
}
